// extracted by mini-css-extract-plugin
export var layout = "Location-module--layout--ab203";
export var info = "Location-module--info--4938f";
export var infoItem = "Location-module--infoItem--89413";
export var infoIcon = "Location-module--infoIcon--aaf6f";
export var infoDescription = "Location-module--infoDescription--31eaa";
export var mapSection = "Location-module--mapSection--665f3";